<!--
  ~ Copyright (c) Worldline 2020.
  -->

<!DOCTYPE html>

<ul class="k-form-steps">
    <li class="item2 third noLeftMargin">
        <div class="strong">Agreements</div>
    </li>
    <li class="item3 third active">
        <div class="strong">Signatures</div>
    </li>
    <li class="item4 third">
        <div class="strong">Summary</div>
    </li>
</ul>

<div class="row">
    <div class="col-md-6">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h5 class="panel-title">Pick colors</h5>
            </div>

            <div class="panel-body">
                <form name="'customizationForm'">
                    <div class="well well-sm">
                        <div class="row">
                            <div class="col-md-12 justify-content-around">
                                <!-- Browse -->
                                <label [attr.uib-tooltip]="'TOOLTIP_FILE_UPLOAD' | translate" class="btn btn-primary btn-file mr-2"
                                       data-tooltip-placement="bottom">
                                    <span class="glyphicon glyphicon-remove"></span>{{"FILE_SELECT" | translate}}
                                    <input (change)="upload($event.target)"
                                           accept=".css"
                                           class="d-none"
                                           id="uploadFile"
                                           name="'uploadFile'"
                                           type="file"/>
                                </label>
                                <!-- Compile -->
                                <span (click)="compile()" class="btn btn-primary mr-2">{{"FILE_COMPILE" | translate}}</span>
                                <!-- Download -->
                                <span (click)="download()" class="btn btn-primary">{{"FILE_DOWNLOAD" | translate}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngFor="let color of Object.keys(colors)" class="col-4 no-label-margin">
                            <label [for]="color">
                                <span class="d-flex justify-content-center">@{{color}}</span>
                            </label>
                            <div class="input-group">
                                <input [(colorPicker)]="colors[color].value" [(ngModel)]="colors[color].value"
                                       [id]="color" [name]="color" class="form-control cursor-pointer custo-color-picker"
                                       maxlength="7" placeholder="#000000" type="text"/>
                                <div [ngStyle]="{'background-color': colors[color].value}" class="input-group-text"></div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h5 class="panel-title">See preview</h5>
            </div>

            <div class="panel-body">
                <h2 class="ng-binding">
                    Titre h2
                    <small class="ng-scope">
                        <span class="ng-binding ng-scope">- Username</span>
                    </small>
                </h2>

                <div class="evidenceSection inputFile transitions-enabled masonry ng-scope ng-isolate-scope">
                    <div class="ng-scope">
                        <h3 class="ng-binding ng-scope">
                            Panel 1: <strong class="ng-binding">Evidence 1</strong>
                        </h3>
                    </div>
                    <br>

                    <ul class="k-buttons-bar ng-scope" id="upload" style="position: inherit;float: none;">
                            <span>
                                <input class="k-help ic-help" style="float: right;" title="Aide" type="button">
                            </span>
                        <span class="ng-scope custom-file custom-file-not-valid">
                                <input accept=",.pjpeg,.jpg,.jpeg,.png,.gif,.pdf" title="Parcourir" type="file" value="Parcourir">
                            </span>
                    </ul>

                </div>
                <p class="k-buttons-bar" style="position: inherit;float: none;">
                    <input class="k-button ic-check" style="float: none;" type="submit" value="Étape suivante">
                </p>
            </div>
        </div>
    </div>
</div>